module.exports = __webpack_public_path__ + "static/media/favorites.9a4b13a6.svg";